import { Link } from "react-router-dom";
import type { Figure } from "@/mocks/figures";
import { categoryMeta } from "./categoryMeta";

export default function FigureCard({ figure }: { figure: Figure }) {
  const meta = categoryMeta(figure.category);
  return (
    <Link
      to={`/renwu/${figure.id}`}
      className="group flex flex-col rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-secondary-200 hover:bg-background-50"
    >
      <div className="flex items-start justify-between gap-3">
        <span
          className={`flex h-12 w-12 shrink-0 items-center justify-center font-display text-xl font-bold ${meta.avatar}`}
        >
          {figure.initial}
        </span>
        <span className="rounded-full px-2.5 py-1 text-xs font-medium text-secondary-900">
          {meta.label}
        </span>
      </div>

      <h3 className="mt-4 font-display text-lg font-bold leading-snug text-foreground-950 group-hover:text-primary-700">
        {figure.name}
      </h3>
      <p className="mt-1 text-xs text-secondary-700">{figure.role}</p>
      <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
        {figure.tagline}
      </p>

      <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
        <span className="text-xs text-secondary-700">
          <i className="ri-time-line mr-1"></i>
          {figure.published} 更新 · {figure.minutes} 分钟阅读
        </span>
        <span className="inline-flex items-center gap-1 text-xs font-medium text-primary-700">
          阅读档案
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
        </span>
      </div>
    </Link>
  );
}